import { QueryClientProvider } from '@tanstack/react-query'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from 'react-router'
import { Toaster } from 'sonner'
import { createQueryClient } from '@/app/query-client'
import { router } from '@/app/router'
import { initSentry, rootErrorOptions } from '@/lib/sentry'
import { initTheme } from '@/lib/theme'
import '@/styles/index.css'

initSentry()
initTheme()

const root = document.getElementById('root')
if (!root) throw new Error('Missing #root element')

createRoot(root, rootErrorOptions).render(
  <StrictMode>
    <QueryClientProvider client={createQueryClient()}>
      <RouterProvider router={router} />
      <Toaster position="bottom-right" duration={7000} />
    </QueryClientProvider>
  </StrictMode>,
)
